<p>workpermit-qr-result works!</p>
